export default function DatabaseSpecificsDefault() {
  return null;
}
